import React from "react";
import { AppSettingScopeSummary } from "../../../types/appSettings";

interface ScopeListProps {
  scopes: AppSettingScopeSummary[];
  selectedScope: string | null;
  onSelect: (scope: string) => void;
  isDarkMode: boolean;
}

const ScopeList: React.FC<ScopeListProps> = ({
  scopes,
  selectedScope,
  onSelect,
  isDarkMode,
}) => {
  return (
    <div className="w-80 flex-shrink-0">
      <div
        className={`text-xs font-semibold uppercase tracking-wider mb-3 ${
          isDarkMode ? "text-rp-grey/50" : "text-gray-500"
        }`}
      >
        Scopes
      </div>
      {scopes.map((s) => (
        <div
          key={s.scope}
          onClick={() => onSelect(s.scope)}
          className={`rounded-lg border p-3.5 mb-2 cursor-pointer transition-colors ${
            selectedScope === s.scope
              ? isDarkMode
                ? "border-rp-amber bg-rp-surface-raised"
                : "border-blue-500 bg-blue-50"
              : isDarkMode
                ? "border-rp-separator bg-rp-surface hover:border-rp-amber"
                : "border-gray-200 bg-white hover:border-blue-400"
          }`}
        >
          <div
            className={`text-sm font-medium font-mono break-all ${
              isDarkMode ? "text-rp-grey" : "text-gray-900"
            }`}
          >
            {s.scope}
          </div>
          <div
            className={`text-xs mt-1 leading-relaxed ${
              isDarkMode ? "text-rp-grey/50" : "text-gray-500"
            }`}
          >
            {s.description}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ScopeList;
